import { ViewVoucherForm } from './view-voucher-form'

export const ViewVoucherModalMainNZ = ({
  voucherId,
  onCloseModal,
}: {
  voucherId: number
  onCloseModal: () => void
}) => {
  return <ViewVoucherForm voucherId={voucherId} onCloseModal={onCloseModal} />
}
